import { render, staticRenderFns } from "./Guizu.vue?vue&type=template&id=39e25f82&scoped=true&"
import script from "./Guizu.vue?vue&type=script&lang=js&"
export * from "./Guizu.vue?vue&type=script&lang=js&"
import style0 from "./Guizu.vue?vue&type=style&index=0&id=39e25f82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e25f82",
  null
  
)

export default component.exports